import React, { Component } from "react";
import styles from "./cmsCompanyRetranslation.module.scss";
import { states } from "../../../../reducers/queriesStates";
import { withRetranslations } from "../../../../shared/containers/containerRetranslations";
import { dateGridLocalTextOptions } from "../../../../shared/services/dataGridLocalTextOptions";
import { MenuItem, Select, Checkbox } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { withCompanies } from "../../../../shared/containers/containerCompanies";

class CmsCompanyRetranslation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedRetranslationId: null,
      retranslationsHosts: [],
    };
  }

  componentDidMount() {
    const { onGetRetranslations, onGetRetranslationsTypes } = this.props;

    onGetRetranslations();
    onGetRetranslationsTypes();
  }

  componentDidUpdate(prevProps) {
    const { retranslationsDataState, retranslations } = this.props;

    if (retranslationsDataState === states.READY && prevProps.retranslationsDataState === states.REQUEST) {
      const retranslationsHosts = retranslations.map((x) => {
        return {
          id: x.id,
          title: x.title,
        };
      });

      this.setState({ retranslationsHosts: retranslationsHosts });
    }
  }

  onChangeType(e) {
    this.setState({ selectedRetranslationId: e.target.value });
  }

  getColumns() {
    const { selectedRetranslationId } = this.state;
    const { onCreateRetranslationUnit, onDeleteRetranslationUnit, companyId } = this.props;

    const renderTitleCell = (params) => {
      return (
        <Checkbox
          checked={params.row.isAdd}
          onChange={() => {
            if (params.row.isAdd)
              onDeleteRetranslationUnit({ retranslationHostId: selectedRetranslationId, unitId: params.row.id }, companyId);
            if (!params.row.isAdd)
              onCreateRetranslationUnit({ retranslationHostId: selectedRetranslationId, unitId: params.row.id }, companyId);
          }}
          style={{
            padding: "0px",
            transform: "scale(1)",
          }}
        />
      );
    };

    return [
      {
        field: "isAdd",
        headerName: "",
        width: 80,
        renderCell: renderTitleCell,
      },
      {
        field: "title",
        headerName: "Наименование",
        width: 400,
      },

      {
        field: "registerNumber",
        headerName: "Гос. номер",
        width: 150,
      },
      {
        field: "imei",
        headerName: "IMEI",
        width: 350,
      },
    ];
  }

  getRows() {
    const { retranslations, companyId, company } = this.props;
    const { selectedRetranslationId } = this.state;

    const retranslation = retranslations.filter((x) => {
      return x.id === selectedRetranslationId;
    })[0];

    if (retranslation === undefined) {
      return [];
    }

    const _company = retranslation.companies.filter((x) => {
      return x.id === companyId;
    })[0];

    return company.units.map((x) => {
      const isAdd =
        _company === undefined
          ? false
          : _company.units.some((u) => {
              return u.id === x.id;
            });

      return {
        id: x.id,
        title: x.title,
        registerNumber: x.registerNumber,
        imei: x.devices[0].imei,
        isAdd: isAdd,
      };
    });
  }

  render() {
    const { retranslationsTypes, retranslations, companyId, company } = this.props;
    const { selectedRetranslationId, retranslationsHosts } = this.state;

    if (retranslationsTypes.length === 0) {
      return null;
    }

    const retranslation = retranslations.filter((x) => {
      return x.id === selectedRetranslationId;
    })[0];

    let count = 0;

    if (retranslation !== undefined) {
      retranslation.companies.forEach((x) => {
        if (companyId === x.id) {
          count += x.units.length;
        }
      });
    }

    return (
      <div className={styles.cmsRetranslationsContainer}>
        Ретрансляция:
        <div className={styles.cmsRetranslationsSelector}>
          <div>
            <Select
              style={{ minWidth: "200px", height: "33px" }}
              onChange={this.onChangeType.bind(this)}
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={selectedRetranslationId}
            >
              {retranslationsHosts.map((x, index) => {
                return (
                  <MenuItem key={index} value={x.id} className={styles.MuiButtonBase_resolve}>
                    {x.title}
                  </MenuItem>
                );
              })}
            </Select>
          </div>

          {retranslation !== undefined ? <div>Адрес: {retranslation.host}</div> : null}
          {retranslation !== undefined ? <div>Порт: {retranslation.port}</div> : null}
          {retranslation !== undefined ? (
            <div>
              По протоколу:{" "}
              {
                retranslationsTypes.types.filter((x) => {
                  return x.id === retranslation.protocol;
                })[0].title
              }
            </div>
          ) : null}

          {retranslation !== undefined ? (
            <div>
              Тип передачи:{" "}
              {
                retranslationsTypes.parameters.filter((x) => {
                  return x.id === retranslation.parameters;
                })[0].title
              }
            </div>
          ) : null}
        </div>
        <div>
          <b>
            Всего ТС: {count} из {company.units.length}
          </b>
        </div>
        <div className={styles.tableContainer}>
          <DataGrid
            rowHeight={30}
            ref={"DataGrid"}
            disableColumnSelector={true}
            disableColumnFilter={false}
            localeText={{
              ...dateGridLocalTextOptions,
              footerRowSelected: (count) => `Транспортных средств выбранно: ${count}`,
              MuiTablePagination: {
                disabled: false,
                rowsPerPage: 100,
                rowsPerPageOptions: 100,
                labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} из ${count === -1 ? `больше ${to}` : count}`,
              },
            }}
            rows={this.getRows()}
            columns={this.getColumns()}
            disableRowSelectionOnClick
          />
        </div>
      </div>
    );
  }
}

export default withCompanies(withRetranslations(React.memo(CmsCompanyRetranslation)));
